import { motion } from 'framer-motion';
import { PHILOSOPHY } from '../../constants/testIds';

const reveal = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

export const Philosophy = () => {
  return (
    <section
      id="philosophy"
      data-testid={PHILOSOPHY.root}
      className="relative bg-[#F5F1E8] py-24 lg:py-36"
    >
      <div className="px-6 md:px-10 lg:px-16 max-w-[1500px] mx-auto">
        <div className="hairline w-full mb-16" />

        <div className="grid grid-cols-12 gap-8 lg:gap-16 items-start">
          {/* Left - text */}
          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: '-80px' }}
            className="col-span-12 lg:col-span-7"
          >
            <div className="flex items-center gap-4 mb-8">
              <span className="w-10 h-px bg-[#A66B45]" />
              <span className="text-[11px] tracking-[0.4em] uppercase text-[#A66B45]">
                The Aravi Philosophy
              </span>
            </div>

            <h2 className="font-serif text-[#18342A] text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight font-light">
              Discovered
              <br />
              <em className="not-italic text-[#A66B45]">first</em>.
              <br />
              Planned around.
            </h2>

            <div className="mt-10 grid sm:grid-cols-2 gap-8 max-w-2xl">
              <p className="text-[#6D6A61] text-base leading-relaxed font-light">
                Aravi is not a project laid on land. It is a piece of land — a
                slow bowl, walled by the 1,100-acre Osmania Geological
                Observatory — that we walked, listened to, and then drew a
                community around.
              </p>
              <p className="text-[#6D6A61] text-base leading-relaxed font-light">
                Every plot inherits the hill view. Every street inherits the
                Miyawaki forest. Within HMDA Limits, transparently priced, and
                built to be lived in for a generation.
              </p>
            </div>

            <div className="mt-12 flex items-center gap-10">
              <div>
                <div className="font-serif text-[#18342A] text-5xl lg:text-6xl leading-none">
                  25<span className="text-[#C9A458]">ac</span>
                </div>
                <div className="mt-2 text-[10px] tracking-[0.4em] uppercase text-[#6D6A61]">
                  Total Land Extent
                </div>
              </div>
              <div className="w-px h-16 bg-[#C9A458]/40" />
              <div>
                <div className="font-serif text-[#18342A] text-5xl lg:text-6xl leading-none">
                  110
                </div>
                <div className="mt-2 text-[10px] tracking-[0.4em] uppercase text-[#6D6A61]">
                  Villas
                </div>
              </div>
              <div className="hidden sm:block w-px h-16 bg-[#C9A458]/40" />
              <div className="hidden sm:block">
                <div className="font-serif text-[#18342A] text-5xl lg:text-6xl leading-none">
                  75<span className="text-[#C9A458]">%</span>
                </div>
                <div className="mt-2 text-[10px] tracking-[0.4em] uppercase text-[#6D6A61]">
                  Natural Oxygen
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right - image */}
          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: '-80px' }}
            transition={{ delay: 0.15 }}
            className="col-span-12 lg:col-span-5 lg:pl-8"
          >
            <div className="relative overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1541963463532-d68292c34b19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxuYXR1cmUlMjBsaWZlc3R5bGUlMjByZWFkaW5nJTIwZm9yZXN0fGVufDB8fHx8MTc4MjczMTIzNnww&ixlib=rb-4.1.0&q=85"
                alt="A quiet morning at an Aravi residence"
                className="w-full aspect-[4/5] object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-[#18342A]/80 to-transparent">
                <p className="font-serif italic text-[#F5F1E8] text-xl md:text-2xl leading-snug">
                  &ldquo;Find the land first. Then plan around it.&rdquo;
                </p>
                <p className="mt-2 text-[#C9A458] text-[10px] tracking-[0.4em] uppercase">
                — Ravikumar Jatoth, Founder &amp; Chairman
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
